import { type JSX } from "react";

/*
This component was originally created for the JSS application codebase.
This is not used for metadata rendering in the Content SDK codebase.
However, this is intentionally retained to prevent React implementation-related
warnings/errors (orange banner) caused by missing component references.
*/
export const Default = (): JSX.Element => {
  return <></>;
};
